export default __webpack_public_path__ + "static/media/enugu-terminal.2cbc6da2.png";